<p-card class="dashBoard">
  <div class="cash-report-dashboard-flex-container clear">
    <div class="cash-report-dashboard-flex-child-left">
      <div class="title" style="width:auto"><span (click)="showCashReport()">Cash Report</span></div>
      <span id="cashReportToolTipIcon" class="infoIcon" calltoaction [calltoactionTemplate]="cashReportToolTipIcon"></span>
    </div>
  </div>
  @if (!data) {
    <div class='loading-spinner'></div>
  }
  @if (data) {
    <div>
      <div class="section">
        <div class="chart-container">
          <p-chart type="doughnut" [data]="chartData" [options]="options" width="128px" height="70px"></p-chart>
          <div class="center chart-overlay">
            <div class="count">{{data.totalAccounts}}</div>
            <div class="label">Accounts</div>
          </div>
        </div>
      </div>
      <irb-panel-button [label]="'Shortfall'" (click)="showCashReportWithCashShortFall()"><span class="count red">{{data.inShortFallCount}}</span></irb-panel-button>
      <irb-panel-button [label]="'Excess'" (click)="showCashReportWithCashInExcess()"><span class="count irb-amber">{{data.inExcessCount}}</span></irb-panel-button>
      <irb-panel-button [label]="'In Range'" (click)="showCashReportWithCashInRange()"><span class="count irb-green">{{data.inRangeCount}}</span></irb-panel-button>
    </div>
  }
</p-card>
<ng-template #cashReportToolTipIcon>
  <div>
    <p>Summary of accounts that have cash in Shortfall, Excess, or In Range.</p>
    <p><strong>Shortfall:</strong> Available Cash is less than the account's Cash Min.</p>
    <p><strong>Excess:</strong> Available Cash is greater than the account's Cash Max.</p>
    <p><strong>In Range:</strong>  Available Cash is within the account's Cash Min/Max.</p>
  </div>
</ng-template>
